import { DatePipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  input,
  output,
} from '@angular/core';

import { ButtonModule, IconModule } from '@hglobal/common';
import { ImageLoaderDirective } from '@pt/directives';
import { FroalaViewModule } from 'angular-froala-wysiwyg';
import { SurveyData } from '@pt/models';
import { TranslateModule } from '@ngx-translate/core';

import { CoinComponent } from '../coin/coin.component';

@Component({
  selector: 'pt-survey-initial-screen',
  templateUrl: './survey-initial-screen.component.html',
  styleUrl: './survey-initial-screen.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    ButtonModule,
    DatePipe,
    TranslateModule,
    ImageLoaderDirective,
    FroalaViewModule,
    CoinComponent,
    IconModule,
  ],
})
export class SurveyInitialScreenComponent {
  survey = input.required<SurveyData>();
  translateSlug = input.required<string>();
  isDisabled = input<boolean>(false);

  startSurvey = output<void>();
  backToInitialScreen = output<void>();

  onStartSurvey() {
    this.startSurvey.emit();
  }
}
